import { render, staticRenderFns } from "./RelatorioPixRecebido.vue?vue&type=template&id=8ace3d74"
import script from "./RelatorioPixRecebido.vue?vue&type=script&lang=js"
export * from "./RelatorioPixRecebido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports